import { render, staticRenderFns } from "./SoAHeader.vue?vue&type=template&id=afd2dce6&"
import script from "./SoAHeader.vue?vue&type=script&lang=js&"
export * from "./SoAHeader.vue?vue&type=script&lang=js&"
import style0 from "./SoAHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports